import styled from "styled-components";
import Colors from "../../../themes/Colors";
import { fadeIn } from "../../../components/Common/CommonStyles";

export const FileUploadContainer = styled.div`
  width: 100%;
  margin-bottom: 20px;
`;

export const DropZone = styled.div`
  border: 2px dashed ${props => props.isDragOver ? Colors.primaryPrimera : Colors.grey};
  border-radius: 8px;
  padding: 40px 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: ${props => props.isDragOver ? Colors.blueTransparent : Colors.inputBg};
  
  &:hover {
    border-color: ${Colors.primaryPrimera};
    background-color: ${Colors.blueTransparent};
  }
  
  animation: ${fadeIn} 0.3s ease-in;
`;

export const FileList = styled.div`
  margin-top: 20px;
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid ${Colors.lineColor};
  border-radius: 8px;
  background-color: ${Colors.greyLight};
`;

export const FileItem = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 15px;
  border-bottom: 1px solid ${Colors.lineColor};
  background-color: ${Colors.white};
  
  &:last-child {
    border-bottom: none;
  }
  
  &:hover {
    background-color: ${Colors.greyLight2};
  }
  
  animation: ${fadeIn} 0.3s ease-in;
`;

export const FileInfo = styled.div`
  flex: 1;
  margin-left: 10px;
  min-width: 0;
`;

export const RemoveButton = styled.button`
  background: none;
  border: none;
  color: ${Colors.huMyHealth};
  font-size: 18px;
  cursor: pointer;
  padding: 5px;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: ${Colors.huMyHealth};
    color: ${Colors.white};
  }
`;

export const FileIcon = styled.div`
  font-size: 24px;
  margin-right: 10px;
  flex-shrink: 0;
`;

export const UploadButton = styled.button`
  background-color: ${Colors.primaryPrimera};
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: ${Colors.primaryPrimera}dd;
  }
  
  &:disabled {
    background-color: ${Colors.grey};
    cursor: not-allowed;
  }
`;
